module.exports = __webpack_public_path__ + "static/media/preview.2921cad9.png";